import Navbar from "@/components/mobix/Navbar";
import Hero from "@/components/mobix/Hero";
import TrustBar from "@/components/mobix/TrustBar";
import Products from "@/components/mobix/Products";
import About from "@/components/mobix/About";
import News from "@/components/mobix/News";
import Showroom from "@/components/mobix/Showroom";
import Contact from "@/components/mobix/Contact";
import Footer from "@/components/mobix/Footer";
import FloatingChat from "@/components/mobix/FloatingChat";
import { Toaster } from "sonner";

export default function Home() {
  return (
    <div className="relative bg-white text-mobix-navy" data-testid="mobix-home">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Products />
        <About />
        <News />
        <Showroom />
        <Contact />
      </main>
      <Footer />
      <FloatingChat />
    </div>
  );
}
